import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

interface Props {
  onClick?: (open: boolean) => void;
}

export const Expand: React.FC<Props> = ({ onClick }) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <FontAwesomeIcon
      aria-label="expand row"
      onClick={() => {
        setOpen(!open);
        !!onClick && onClick(!open);
      }}
      icon={open ? faCaretUp : faCaretDown}
      color="blue"
      size="2x"
    />
  );
};
